import styles from "./SegmentedControl.module.css";

export type SegmentOption = {
  value: string;
  label: string;
};

export type SegmentedControlProps = {
  value: string;
  onChange: (value: string) => void;
  options: SegmentOption[];
  "aria-label"?: string;
};

export const SegmentedControl = ({
  value,
  onChange,
  options,
  "aria-label": ariaLabel = "Options",
}: SegmentedControlProps) => (
  <div role="radiogroup" aria-label={ariaLabel} className={styles.group}>
    {options.map((opt) => {
      const active = opt.value === value;
      return (
        <button
          key={opt.value}
          type="button"
          // biome-ignore lint/a11y/useSemanticElements: button with role=radio is intentional; styled segmented control, not an input
          role="radio"
          aria-checked={active}
          data-active={active ? "true" : "false"}
          className={styles.segment}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);
